import React, { useRef } from 'react';
import ReactToPrint from 'react-to-print';
import { Button } from 'reactstrap';
import PrintOfficialReceipt from './printOfficialReceipt';

const PrintTranscation = ({ selectedData }) => {
  const printRef = useRef();

  return (
    <>
      <ReactToPrint
        trigger={() => {
          return (
            <Button size='sm'>
              <i className='fa fa-file-archive mr-2' />
              {/* {t('print')} */}
            </Button>
          );
        }}
        content={() => printRef.current}
      />
      <div id='print' style={{ display: 'none' }}>
        <PrintOfficialReceipt ref={printRef} data={selectedData} />
      </div>
    </>
  );
};

export default PrintTranscation;
